// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreateFulfillmentOrderRequest,
  FulfillmentOrder,
  fulfillmentOrderSchema,
} from '@/fulfillment/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Creates a new fulfillment order with the specified details.
 */
export async function createFulfillmentOrder(
  request: CreateFulfillmentOrderRequest
): Promise<FulfillmentOrder> {
  const url = '/v1/fulfillment';
  const apiRequest = {
    ...request,
    promiseShipDate: serializeDateForAPI(request.promiseShipDate),
    promiseDeliveryDate: serializeDateForAPI(request.promiseDeliveryDate),
  };
  const response = await api.post<ApiResponse>(url, apiRequest);

  // Parse and validate the response with Zod
  return parseResponse(fulfillmentOrderSchema, response.data.data, {
    schemaName: 'CreateFulfillmentOrder',
    endpoint: url,
  });
}
